import React from "react";
export default function FilterBadge({ count, }) {
    return (<span className="inline-flex items-center justify-center min-w-5 h-5 px-1 rounded-full bg-[#0071CE] text-white text-xs leading-none">
      {count}
    </span>);
}
